import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router-dom';
import { Loader } from 'src/components/SuspenseLoader/Loader';
import { lazy } from 'react';

import AuthGuard from './layouts/Auth/AuthGuard';
import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import JwtAdminLogin from './content/public/JwtAdminLogin';

const JwtLogin = Loader(lazy(() => import('src/content/public/JwtLogin')));
const JwtRegister = Loader(lazy(() => import('src/content/public/JwtRegister')));
const VerifyAccount = Loader(lazy(() => import('src/content/public/VerifyAccount')));

// Dashboard
const Dashboard = Loader(lazy(() => import('src/content/dashboard')));

// Settings
const GeneralSettings = Loader(lazy(() => import('src/content/settings')));

// Admins
const AdminManagement = Loader(lazy(() => import('src/content/admins')));
const CreateAdmin = Loader(lazy(() => import('src/content/admins/create/CreateAdmin')));
const AdminProfile = Loader(lazy(() => import('src/content/admins/profile')));

// Licenses
const CreateLicense = Loader(lazy(() => import('src/content/licenses/CreateLicense')));

// References
const References = Loader(lazy(() => import('src/content/references')));

// Course
const Submodule = Loader(lazy(() => import('src/content/course/index')));

// Status
const Status404 = Loader(lazy(() => import('src/layouts/Status404')));
const Community = Loader(lazy(() => import('src/content/community')));
const CommunityCategory = Loader(lazy(() => import('src/content/community/Category')));

const routes: RouteObject[] = [
  {
    path: '/content/*',
    element: null,
    loader: () => {
      return null;
    }
  },
  {
    element: (<AuthGuard>
      <BaseLayout />
    </AuthGuard>),
    children: [
      {
        element: <SidebarLayout />,
        children: [
          {
            path: 'dashboard',
            element: <Dashboard />
          },
          {
            path: 'course/submodules/:submoduleId',
            element: <Submodule />
          },
          {
            path: 'settings',
            element: <GeneralSettings />
          },
          {
            path: 'admins/manage',
            element: <AdminManagement />
          },
          {
            path: 'admins/create',
            element: <CreateAdmin />
          },
          {
            path: 'admins/profile/:queryUID',
            element: <AdminProfile />
          },
          {
            path: 'licenses',
            element: <CreateLicense />
          },
          {
            path: 'references',
            element: <References />
          }
        ]
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          }
        ]
      }
    ]
  },
  {
    path: 'community',
    element: <BaseLayout />,
    children: [
      { path: '', element: <Community /> },
      { path: ':type', element: <CommunityCategory /> }
    ]
  },
  { path: `/signup/:lang`, element: <JwtRegister /> },
  { path: `/signup`, element: <Navigate to='/signup/pt' /> },
  { path: `/signin/:lang`, element: <JwtLogin /> },
  { path: `/admin/:lang`, element: <JwtAdminLogin /> },
  { path: `/signin`, element:  <Navigate to='/signin/pt' /> },
  { path: `/forgot-password`, element: <Navigate to='/forgot-password/pt' /> },
  { path: `/verify/:lang/:token`, element: <VerifyAccount /> },
  { path: '/404', element: <Status404 /> },
  { path: '/', element: <Navigate to="dashboard" replace /> },
  { path: '*', element: <Status404 /> }
];

export default routes;
